import { CustomCarousel } from "../components/customCarousel";
const $ = window.jQuery;
export class LovePromisePage {
    constructor() {
        this._carousels = [];
        this.addEventHandlers();
        this.initializeCarousels();
        this.submitStoryFooterObserver();
        this.submitStoryNonFooterObserver();
    }
    addEventHandlers() {
        const heroVideoScrollBtn = document.querySelector(".scroll-container__button");
        const moreStoriesBtn = document.querySelector(".more-stories-btn");
        const causeLinks = document.querySelectorAll(".item-link");
        const causePopups = document.querySelectorAll(".item-popup");
        heroVideoScrollBtn?.addEventListener("click", () => {
            $("html, body").animate({
                scrollTop: $("#participationSection").offset().top,
            }, 2000);
        });
        //need to apply styling after bootstrap opens the modal
        $(".submit-story-modal").on("shown.bs.modal", this.alignModal);
        moreStoriesBtn?.addEventListener("click", (e) => {
            const hiddenStories = document.querySelectorAll(".dealer-story.hide");
            hiddenStories.forEach((story) => {
                story.classList.remove("hide");
            });
            e.currentTarget.setAttribute("disabled", "true");
        });
        causeLinks.forEach((link) => {
            link.addEventListener("click", () => {
                const parent = link.closest(".item-container");
                const popup = parent?.querySelector(".item-popup");
                const popupIsOpen = parent.classList.contains("popup-caret");
                if (popupIsOpen) {
                    this.closePopup(popup);
                    return;
                }
                if (this._currentPopup) {
                    this.closePopup(this._currentPopup);
                }
                parent.classList.add("popup-caret");
                popup?.toggleAttribute("hidden");
                link.setAttribute("aria-expanded", "true");
                this._currentPopup = popup;
            });
        });
        causePopups.forEach((popup) => {
            popup.addEventListener("click", () => {
                this.closePopup(popup);
            });
        });
    }
    closePopup(popup) {
        const parent = popup.closest(".item-container");
        const causeLink = parent.querySelector(".item-link");
        parent.classList.remove("popup-caret");
        popup?.toggleAttribute("hidden");
        causeLink.setAttribute("aria-expanded", "false");
        causeLink.focus();
        this._currentPopup = undefined;
    }
    /* v8 ignore start */
    // Ignoring until someone can figure out how to test IntersectionObserver in a reasonable way
    // - I've had no luck
    submitStoryFooterObserver() {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.05,
        };
        const container = document.querySelector(".submit-story-container");
        const observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                container.classList.add("submit-story-container--sticky");
                container.classList.remove("container");
            }
            else {
                container.classList.remove("submit-story-container--sticky");
                container.classList.add("container");
            }
        }, options);
        const target = document.getElementById("dealerStoriesSection");
        observer.observe(target);
    }
    submitStoryNonFooterObserver() {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0,
        };
        const container = document.querySelector(".submit-story-container");
        const observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                container.classList.add("container");
                container.classList.remove("submit-story-container--sticky");
            }
            else {
                container.classList.remove("container");
                this.submitStoryFooterObserver();
            }
        }, options);
        const target = document.querySelector(".submit-story-section__end");
        observer.observe(target);
    }
    /* v8 ignore stop */
    initializeCarousels() {
        const hasAutoPlay = false;
        const hasDotNavigation = true;
        this._customCarouselElements = document.querySelectorAll(".custom-carousel[id^='dealerStoryCarousel']");
        this._customCarouselElements.forEach((carouselElement) => {
            const carousel = new CustomCarousel(carouselElement, hasAutoPlay, hasDotNavigation);
            this._carousels.push(carousel);
            carousel.activateCustomCarousel();
        });
    }
    alignModal() {
        const modal = document.querySelector(".submit-story-modal");
        modal.style.display = "flex";
        modal.style.alignItems = "center";
    }
}
window.DoUtility.SelfInstantiateOnLoad(LovePromisePage);
